// src/pages/BlogPage.jsx
import { useContext, useEffect, useState } from "react";
import { Typography, Spin, Card, Skeleton, Col, Row } from "antd";
import BlogSliderSwiper from "./Component/BlogSlider";
import { useHttp } from "../../../utils/DataHendler";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../../context/Language.contex";

const { Title } = Typography;

const BlogPage = () => {
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);

  const [data, setData] = useState([]);
  const { getData } = useHttp();
  const [filters, setFilters] = useState({});
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 4,
    total: 0,
    totalPages: 0,
  });
  const [loading, setLoading] = useState(false);

  const fetchData = async (queryParams) => {
    setLoading(true);
    try {
      const response = await getData(`/event`, { params: queryParams }, false);
      if (response.success) {
        const structuredData = response.data.data.map((item) => ({
          ...item,
          key: item.id,
        }));

        setData(structuredData);
        setPagination({
          page: response.data.pagination.page,
          limit: response.data.pagination.limit,
          total: response.data.pagination.total,
          totalPages: response.data.pagination.totalPages,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    fetchData({ ...filters, page: newPage, limit: pagination.limit });
  };

  useEffect(() => {
    fetchData({ page: pagination.page, limit: pagination.limit });
  }, []);

  return (
    <div style={{ padding: "50px 10px", background: "#f9fafe" }}>
      <div style={{ textAlign: "center" }}>
        <Typography.Text type="secondary" style={{ fontWeight: "bold" }}>
          {language[12]}
        </Typography.Text>
        <Title level={2} style={{ marginTop: 5 }}>
          {language[13]}
        </Title>
      </div>

      {loading ? (
        <Row gutter={[24, 24]}>
          {Array.from({ length: 6 }).map((_, idx) => (
            <Col xs={24} sm={12} md={8} key={idx}>
              <Card
                cover={
                  <Skeleton.Image
                    active
                    style={{ width: "100%", height: 200 }}
                  />
                }
              >
                <Skeleton
                  active
                  paragraph={{ rows: 2 }}
                  title={{ width: "80%" }}
                />
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <BlogSliderSwiper
          data={data}
          onPageChange={handlePageChange}
          pagination={pagination}
        />
      )}
    </div>
  );
};

export default BlogPage;
